import { ListChats } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

export const GetAllChats = {
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      ChatsList: {},
    };
  },
  methods: {
    async GetAllChatsMethod() {
      try {
        this.overlay = true;
        var inputParams = {
          lister: "POLICE",
          user_id: this.$store.getters.get_current_user_details.user_id,
          other_user_id: this.$store.getters.get_motorist_name.user_id,
        };

        let result = await API.graphql(
          graphqlOperation(ListChats, {
            input: inputParams,
          })
        );
        this.ChatsList = JSON.parse(result.data.ListChats).data[0];
        this.$store.commit("SET_CHAT_LIST", this.ChatsList);
      } catch (error) {
        console.log("Check error", error);
        this.overlay = false;
      }
    },
  },
};
